import { Database } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import { findChatByConnectionKeyAndPhoneNumber } from '../readers'

export const archiveChat = async (payload: ComponentInfoChatVO, database: Database) => {
  await database.write(async writer => {
    try {
      const chat = await writer.callReader(
        async () => await findChatByConnectionKeyAndPhoneNumber(payload.connectionKey, payload.phoneNumber, database)
      )
      if (chat) {
        await writer.callWriter(async () => await chat.markAsArchived(payload))
      }
    } catch (e) {
      console.error(e)
    }
  })
}
